import { Component, OnInit } from '@angular/core';
import { BoardEditorFilter, BoardService } from 'src/app/_provider/boards/board.service';

@Component({
  selector: 'app-board-ediorviewer-select',
  templateUrl: './board-ediorviewer-select.component.html',
  styleUrls: ['./board-ediorviewer-select.component.scss', '../board-select.scss'],
})
export class BoardEdiorviewerSelectComponent implements OnInit {

  public newEditorFilterSelected: (data: BoardEditorFilter) => void
  public editorFilter: BoardEditorFilter = BoardEditorFilter.ALL

  constructor(
    public boardSrv: BoardService
  ) { }

  ngOnInit() {}

}
